import React, { Component, PropTypes } from 'react';

export default class FloatingActionButton extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        color: PropTypes.string,
        icon: PropTypes.string
    };

    static defaultProps = {
        color: 'blue',
        icon: 'glyphicon glyphicon-plus'
    };

    handleClick = () => {
        this.props.onClick();
    };

    render() {
        return (
            <a href="#"
               className={'btn btn-circle btn-icon-only tooltips ' + this.props.color}
               data-container="body"
               data-placement="top"
               data-original-title={this.props.title}
               onClick={this.handleClick}
               style={{position: 'fixed',
                        bottom: '3%',
                        right: '3%',
                        width: '50px',
                        height: '50px',
                        paddingTop: '15px',
                        zIndex: '6'}}>
                <i className={this.props.icon}></i>
            </a>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Buttons/FloatingActionButton.js
 **/